import React from "react";
import {
  View,
  StyleSheet
} from "react-native";

import Style from "ae-style";

const styles = StyleSheet.create({
	line: {
		borderBottomColor: Style.colors.itemLightGray,
		borderBottomWidth: 2,
		width: "100%"
	}
});

export default function HorizontalRule(props){
	const style = props.style;
	const viewStyle = [styles.line];
	if(style) viewStyle.push(style);

	return (
		<View style={viewStyle} />
	);
}